module.exports = __webpack_public_path__ + "img/ch45.1580650f.jpg";